import React, { useEffect, useState } from "react";
import AppUpdateForm from "./AppUpdateForm";
import "./appUpdate.css";

import {
  fetchAllAppUpdates,
  deleteAppUpdate as deleteAppUpdateService,
  toggleAppUpdateStatus
} from "./adminAppUpdateService";

const AdminAppUpdatePage = () => {
  const [updates, setUpdates] = useState([]);
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadUpdates();
  }, []);

  /**
   * Load all app updates
   */
  const loadUpdates = async () => {
    setLoading(true);

    const response = await fetchAllAppUpdates();

    if (response.status === 200) {
      setUpdates(response.data);
    } else {
      alert(response.message || "Failed to load app updates");
    }

    setLoading(false);
  };

  /**
   * Delete update config
   */
  const deleteAppUpdate = async (id) => {
    if (!window.confirm("Delete this app update config?")) return;

    const response = await deleteAppUpdateService(id);

    if (response.status === 200 || response.status === 204) {
      loadUpdates();
    } else {
      alert(response.message || "Delete failed");
    }
  };

  /**
   * Enable / Disable update config
   */
  const toggleEnable = async (id, currentActive) => {
    const response = await toggleAppUpdateStatus(id, !currentActive);

    if (response.status === 200) {
      loadUpdates();
    } else {
      alert(response.message || "Status update failed");
    }
  };

  /**
   * Edit update config
   */
  const editAppUpdate = (update) => {
    setEditing(update);
    setShowForm(true);
  };

  /**
   * Create new update config
   */
  const newAppUpdate = () => {
    setEditing(null);
    setShowForm(true);
  };

  /**
   * After save refresh list
   */
  const onFormSaved = () => {
    setShowForm(false);
    loadUpdates();
  };

  return (
    <div className="admin-container">
      <div className="admin-header">
        <h2>App Update Management</h2>

        <button onClick={newAppUpdate}>
          + New App Update
        </button>
      </div>

      {showForm && (
        <AppUpdateForm
          appUpdate={editing}
          onSaved={onFormSaved}
          onCancel={() => setShowForm(false)}
        />
      )}

      {loading ? (
        <p>Loading app updates...</p>
      ) : (
        <table className="announcement-table">
          <thead>
            <tr>
              <th>Platform</th>
              <th>Package Name</th>
              <th>Latest Version</th>
              <th>Min Supported</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {updates.length === 0 ? (
              <tr>
                <td colSpan="6">No app update configs found</td>
              </tr>
            ) : (
              updates.map((u) => (
                <tr key={u.id}>
                  <td>{u.platform}</td>
                  <td>{u.packageName}</td>
                  <td>
                    {u.latestVersionName} ({u.latestVersionCode})
                  </td>
                  <td>{u.minSupportedVersionCode}</td>
                  <td>
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={u.active}
                        onChange={() => toggleEnable(u.id, u.active)}
                      />
                      <span className="slider"></span>
                    </label>
                  </td>
                  <td>
                    <button onClick={() => editAppUpdate(u)}>
                      Edit
                    </button>

                    <button
                      className="delete-btn"
                      onClick={() => deleteAppUpdate(u.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AdminAppUpdatePage;